import { render, staticRenderFns } from "./InterviewerPageTabs.vue?vue&type=template&id=39c7c7f8&scoped=true"
import script from "./InterviewerPageTabs.vue?vue&type=script&lang=js"
export * from "./InterviewerPageTabs.vue?vue&type=script&lang=js"
import style0 from "./InterviewerPageTabs.vue?vue&type=style&index=0&id=39c7c7f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c7c7f8",
  null
  
)

export default component.exports